(() => {
  const T = window.theme || { strings: {}, routes: {} };
  const S = T.strings;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mq = matchMedia('(max-width: 749px)');
  const isMobile = () => mq.matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => (cents / 100).toLocaleString(T.locale === 'es' ? 'es-ES' : T.locale, { style: 'currency', currency: T.currency || 'EUR' });
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const root = (T.routes.cart || '/cart').replace(/\/cart$/, '');

  let tt;
  function toast(m) {
    const t = $('#toast');
    if (!t) return;
    t.textContent = m;
    t.classList.add('on');
    clearTimeout(tt);
    tt = setTimeout(() => t.classList.remove('on'), 2600);
  }

  function openDrawer(id) {
    closeAll(true);
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    $('#scrim')?.classList.add('on');
    if (id === 'search') setTimeout(() => $('#q')?.focus(), 300);
  }
  function closeAll(keep) {
    $$('.drawer,.search').forEach((d) => { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    if (!keep) $('#scrim')?.classList.remove('on');
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.open); if (o.dataset.open === 'cart') refreshCart(); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  function swapDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const cur = $('[data-cart-drawer]');
    if (!fresh || !cur) return;
    const wasOpen = cur.classList.contains('on');
    cur.innerHTML = fresh.innerHTML;
    cur.dataset.count = fresh.dataset.count;
    cur.classList.remove('loading');
    if (wasOpen) { cur.classList.add('on'); cur.setAttribute('aria-hidden', 'false'); }
    $$('[data-cart-count]').forEach((n) => (n.textContent = fresh.dataset.count));
  }
  async function refreshCart() {
    try {
      const r = await fetch(`${root}/?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
      const j = await r.json();
      swapDrawer(j['cart-drawer']);
    } catch (e) {}
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    b.disabled = true;
    $('[data-cart-drawer]')?.classList.add('loading');
    try {
      const r = await fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.qty, sections: 'cart-drawer' }) });
      if (!r.ok) throw 0;
      const j = await r.json();
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      swapDrawer(j.sections && j.sections['cart-drawer']);
    } catch (err) { toast(S.error); $('[data-cart-drawer]')?.classList.remove('loading'); }
  });
  async function addToCart(form) {
    const btn = form.querySelector('[type=submit]');
    btn && (btn.disabled = true);
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      const r = await fetch(root + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const j = await r.json();
      if (!r.ok) { toast(j.description || S.error); return; }
      if (j.sections && j.sections['cart-drawer']) swapDrawer(j.sections['cart-drawer']); else await refreshCart();
      toast(S.added);
      openDrawer('cart');
    } catch (err) { form.submit(); }
    finally { btn && (btn.disabled = false); }
  }

  function initProduct(sec) {
    const data = JSON.parse($('[data-product-json]', sec)?.textContent || 'null');
    if (!data) return;
    const form = $('form[data-product-form]', sec);
    const idInput = form && $('input[name=id]', form);
    if (!idInput) return;
    const btn = $('[data-add]', sec);
    const sel = data.options.map((_, i) => { const v = data.variants.find((x) => x.id == idInput.value) || data.variants[0]; return v.options[i]; });
    const find = () => data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    const avail = (i, val) => data.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || o === sel[j]));
    const gallery = $('[data-gallery]', sec);
    const norm = (x) => String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-');
    const colorIdx = data.options.findIndex((o) => /color|colour/i.test(o));
    let lastMedia = null;
    let firstDraw = !new URLSearchParams(location.search).has('variant');
    let fromBar = false, pending = null;
    const showVariantMedia = (v) => {
      if (fromBar) { pending = v; return; }
      if (firstDraw) { firstDraw = false; return; }
      if (!gallery || !v) return;
      let f = v.featured_media ? $(`[data-media-id="${v.featured_media.id}"]`, gallery) : null;
      if (!f && colorIdx > -1) {
        const want = norm(v.options[colorIdx]);
        f = $$('figure', gallery).find((fig) => norm(fig.dataset.alt + ' ' + (fig.querySelector('img')?.currentSrc || '').split('/').pop()).includes(want));
      }
      if (!f || f === lastMedia) return;
      lastMedia = f;
      if (gallery.firstElementChild !== f) {
        gallery.prepend(f);
        f.querySelector('img')?.setAttribute('loading', 'eager');
        f.animate?.([{ opacity: 0.2 }, { opacity: 1 }], { duration: 450, easing: 'ease-out' });
      }
      if (matchMedia('(max-width:900px)').matches) gallery.scrollTo({ left: 0, behavior: 'smooth' });
      else { const top = gallery.getBoundingClientRect().top; if (top < 0) window.scrollTo({ top: scrollY + top - 120, behavior: 'smooth' }); }
      gallery.dispatchEvent(new Event('scroll'));
    };
    const draw = () => {
      const v = find();
      $$('[data-opt]', sec).forEach((group) => {
        const i = +group.dataset.opt;
        $('[data-selected]', group).textContent = sel[i];
        $$('.val', group).forEach((b) => { b.classList.toggle('on', b.dataset.v === sel[i]); b.classList.toggle('na', !avail(i, b.dataset.v)); b.setAttribute('aria-pressed', b.dataset.v === sel[i]); });
      });
      const pv = v || data.variants[0];
      const price = $('[data-price]', sec);
      if (price) price.innerHTML = pv.compare_at_price > pv.price ? `<span style="color:var(--sale)">${money(pv.price)}</span><s>${money(pv.compare_at_price)}</s><span class="off">-${Math.round((1 - pv.price / pv.compare_at_price) * 100)}%</span>` : `<span>${money(pv.price)}</span>`;
      const ok = v && v.available;
      if (v) idInput.value = v.id;
      if (btn) {
        btn.disabled = !ok;
        btn.textContent = !v ? S.unavailable : ok ? (btn.dataset.label || S.addToCart) : S.soldOut;
      }
      const sb = $('#sbBtn');
      if (sb) {
        sb.disabled = !ok;
        const l = $('.bt-l', sb), sh = $('.bt-s', sb);
        if (l && sh) {
          const lab = ok ? (btn?.dataset.label || S.addToCart) : (v ? S.soldOut : S.unavailable);
          l.textContent = lab; sh.textContent = ok ? (S.add || 'Añadir') : lab;
          sb.classList.toggle('na', !ok);
        }
      }
      const st = $('#sbT'); if (st) st.textContent = data.title.split(' - ')[0];
      $$('#sbOpts select').forEach((sl) => { const i = +sl.dataset.i; [...sl.options].forEach((o) => { o.textContent = avail(i, o.value) ? o.value : `${o.value} · ${String(S.soldOut || 'agotado').toLowerCase()}`; }); sl.value = sel[i]; });
      const sp = $('#sbP'); if (sp) sp.textContent = money(pv.price);
      const si = $('#sbImg');
      if (si && v && v.featured_media) { const im = $(`[data-media-id="${v.featured_media.id}"] img`, sec); const u = im && (im.currentSrc || im.src); if (u) si.src = u; }
      showVariantMedia(v);
      const stock = $('[data-stock]', sec);
      if (stock) {
        const n = v && v.available ? v.inventory : null;
        const low = +stock.dataset.threshold || 5;
        if (n != null && n > 0 && n <= low) { $('span', stock).textContent = n === 1 ? stock.dataset.textOne : stock.dataset.text.replace('__N__', n); stock.hidden = false; } else stock.hidden = true;
      }
      if (v && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    };
    sec.addEventListener('click', (e) => { const b = e.target.closest('.val'); if (!b) return; sel[+b.closest('[data-opt]').dataset.opt] = b.dataset.v; draw(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form); });
    const sbOpts = $('#sbOpts');
    if (sbOpts && !(data.options.length === 1 && /title|t[ií]tulo/i.test(data.options[0]))) {
      sbOpts.innerHTML = data.options.map((name, i) => { const vals = [...new Set(data.variants.map((x) => x.options[i]))]; return `<label class="sb-sel"><span>${esc(name)}</span><select data-i="${i}" aria-label="${esc(name)}">${vals.map((val) => `<option value="${esc(val)}">${esc(val)}</option>`).join('')}</select></label>`; }).join('');
      sbOpts.addEventListener('change', (e) => { const sl = e.target.closest('select'); if (!sl) return; sel[+sl.dataset.i] = sl.value; fromBar = true; draw(); fromBar = false; });
    }
    $('#sbBtn')?.addEventListener('click', () => form.requestSubmit());
    draw();
    const sb = $('#stickybuy');
    if (sb && btn) {
      let rel = null;
      const measure = () => { if (scrollY < 40) { const r = btn.getBoundingClientRect(), t = sec.getBoundingClientRect(); rel = r.bottom - t.top; } };
      const check = () => {
        const r = btn.getBoundingClientRect();
        let past = r.height > 0 && r.bottom < 0;
        if (!past && rel != null) { const top = sec.getBoundingClientRect().top + scrollY; past = scrollY > top + rel; }
        sb.classList.toggle('show', past);
        if (!past && pending) { const pv2 = pending; pending = null; showVariantMedia(pv2); }
      };
      let ticking = false;
      const on = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; check(); }); };
      measure();
      addEventListener('scroll', on, { passive: true });
      addEventListener('resize', () => { measure(); on(); });
      addEventListener('load', () => { measure(); check(); });
      check();
    }
  }

  let sTimer;
  function initSearch() {
    const q = $('#q'), out = $('#qres');
    if (!q) return;
    q.addEventListener('input', () => {
      clearTimeout(sTimer);
      sTimer = setTimeout(async () => {
        const term = q.value.trim();
        if (!term) { out.innerHTML = out.dataset.initial || ''; return; }
        try {
          const r = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = doc.querySelector('[data-results]');
          out.innerHTML = res ? res.innerHTML : `<p class="small">${esc(S.noResults)}</p>`;
        } catch (e) {}
      }, 220);
    });
    out.dataset.initial = out.innerHTML;
  }

  let io;
  function armReveals(scope = document) {
    if (reduce) return;
    io = io || new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.remove('pre'); io.unobserve(e.target); } }), { rootMargin: isMobile() ? '0px 0px 12% 0px' : '0px 0px -8% 0px' });
    $$('.rv,.rv-img', scope).forEach((el) => { const r = el.getBoundingClientRect(); if (r.top > innerHeight * (isMobile() ? 1.02 : 0.92)) { el.classList.add('pre'); io.observe(el); } });
  }

  const hdr = $('.section-header') || $('.site');
  let lastY = scrollY, vel = 0;
  function measure() {
    if (hdr) document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    $$('.hscroll').forEach((hs) => {
      const rail = $('.rail', hs);
      const native = reduce || isMobile();
      hs.classList.toggle('native', native);
      hs.style.height = native ? '' : rail.scrollWidth - innerWidth + innerHeight + innerWidth * 0.15 + 'px';
      if (native) rail.style.transform = '';
    });
  }
  const clamp = (v) => Math.min(1, Math.max(0, v));
  function tick() {
    const y = scrollY, vh = innerHeight;
    vel = vel * 0.85 + (y - lastY) * 0.15;
    const max = document.documentElement.scrollHeight - vh;
    const pg = $('#progress'); if (pg) pg.style.transform = `scaleX(${max > 0 ? y / max : 0})`;
    if (hdr) { if (y > 200 && y > lastY + 4) hdr.classList.add('hide'); else if (y < lastY - 4 || y < 200) hdr.classList.remove('hide'); }
    lastY = y;
    if (reduce) return;
    $$('[data-par]').forEach((el) => { const r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return; const c = r.top + r.height / 2 - vh / 2; el.style.transform = `translate3d(0,${(-c * parseFloat(el.dataset.par)).toFixed(1)}px,0)`; });
    $$('.hero').forEach((hero) => { const top = hero.getBoundingClientRect().top + y; const k = clamp((y - top) / hero.offsetHeight); const bg = $('.bg', hero), cp = $('.copy', hero); if (bg) bg.style.transform = `translate3d(0,${(y - top) * 0.35 * (k > 0 ? 1 : 0)}px,0) scale(${1 + k * 0.08})`; if (cp) cp.style.opacity = 1 - k * 1.3; });
    $$('.hscroll:not(.native)').forEach((hs) => { const r = hs.getBoundingClientRect(); const k = clamp(-r.top / (hs.offsetHeight - vh)); const rail = $('.rail', hs); const dist = rail.scrollWidth - innerWidth; rail.style.transform = `translate3d(${-k * dist}px,0,0)`; const bar = $('.hbar i', hs); if (bar) bar.style.transform = `scaleX(${k})`; const n = rail.children.length; const ct = $('.counter', hs); if (ct) ct.textContent = `${String(Math.min(n, 1 + Math.round(k * (n - 1)))).padStart(2, '0')} / ${String(n).padStart(2, '0')}`; });
    $$('.expand').forEach((ex) => { const r = ex.getBoundingClientRect(); const k = clamp(-r.top / (ex.offsetHeight - vh)); const ins = 1 - Math.min(1, k * 1.6); const sx = 12 * ins, sy = 18 * ins; $('.frame', ex).style.clipPath = `inset(${sy}% ${sx}% ${sy}% ${sx}% round ${ins * 4}px)`; const im = $('.frame img', ex); if (im) im.style.transform = `scale(${1.25 - k * 0.25})`; $('.txt', ex).style.transform = `translate3d(0,${(0.5 - k) * 80}px,0)`; });
    $$('.js-manif').forEach((m) => { const r = m.getBoundingClientRect(); const k = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35)); const ws = m.children; const lit = Math.floor(k * ws.length * 1.05); for (let i = 0; i < ws.length; i++) ws[i].classList.toggle('dim', i >= lit); });
    if (!isMobile()) $$('.js-drift').forEach((rr) => { const r = rr.getBoundingClientRect(); const k = clamp((vh - r.top) / (vh + r.height)); const dist = Math.max(0, rr.scrollWidth - innerWidth); rr.style.transform = `translate3d(${-k * dist}px,0,0)`; });
  }
  let raf = 0;
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; tick(); }); }, { passive: true });
  addEventListener('resize', () => { measure(); tick(); });

  const marquees = [];
  function loop() {
    if (!reduce) {
      marquees.forEach((m) => {
        m.x -= m.speed + (m.scroll ? vel * 0.25 : Math.abs(vel) * 0.06);
        const w = m.el.scrollWidth / 2;
        if (-m.x > w) m.x += w;
        if (m.x > 0) m.x -= w;
        m.el.style.transform = `translate3d(${m.x}px,0,0)`;
      });
      vel *= 0.96;
    }
    requestAnimationFrame(loop);
  }

  function initContact() {
    $$('[data-copy]').forEach((b) => b.addEventListener('click', () => {
      const t = b.dataset.copy;
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(() => toast('✓ ' + t)).catch(() => {});
    }));
  }

  function railProgress(wrap, hs) {
    const rail = $('.rail', hs);
    const upd = () => {
      if (!hs.classList.contains('native')) return;
      const max = wrap.scrollWidth - wrap.clientWidth;
      const k = max > 0 ? wrap.scrollLeft / max : 0;
      const bar = $('.hbar i', hs); if (bar) bar.style.transform = `scaleX(${Math.max(0.08, k)})`;
      const n = rail.children.length, ct = $('.counter', hs);
      if (ct) ct.textContent = `${String(Math.min(n, 1 + Math.round(k * (n - 1)))).padStart(2, '0')} / ${String(n).padStart(2, '0')}`;
    };
    wrap.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    upd();
  }
  function initGallery(g) {
    const wrap = g.closest('.gal-wrap'); if (!wrap) return;
    const dots = $$('.gal-ui i', wrap), count = $('[data-gal-count]', wrap), n = g.children.length;
    g.addEventListener('scroll', () => requestAnimationFrame(() => {
      const i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
      if (count) count.textContent = `${Math.min(n, i + 1)} / ${n}`;
    }), { passive: true });
  }

  /* Visor de imágenes de la ficha: ampliar, zoom y pasar fotos desde dentro */
  function initLightbox() {
    if (initLightbox.done) return; initLightbox.done = true;
    let box, stage, img, counter, items = [], idx = 0, s = 1, tx = 0, ty = 0, opener = null, lastTap = 0;
    const ptrs = new Map();
    let g0 = null;
    const MAX = 4;
    const clamp = () => {
      const w = img.offsetWidth * s, h = img.offsetHeight * s;
      const mx = Math.max(0, (w - stage.clientWidth) / 2), my = Math.max(0, (h - stage.clientHeight) / 2);
      tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
    };
    const apply = (anim) => {
      img.style.transition = anim ? 'transform .25s cubic-bezier(.2,.7,.2,1)' : 'none';
      img.style.transform = `translate(${tx}px,${ty}px) scale(${s})`;
      box.classList.toggle('zoomed', s > 1.01);
    };
    const zoomAt = (ns, cx, cy, anim) => {
      ns = Math.min(MAX, Math.max(1, ns));
      const r = stage.getBoundingClientRect(), px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
      tx = px - (px - tx) * (ns / s); ty = py - (py - ty) * (ns / s); s = ns;
      if (s === 1) { tx = 0; ty = 0; } else clamp();
      apply(anim);
    };
    const show = (i, dir) => {
      idx = (i + items.length) % items.length; s = 1; tx = 0; ty = 0;
      img.style.opacity = '0';
      img.onload = () => { img.style.opacity = ''; };
      img.src = items[idx].src; img.alt = items[idx].alt;
      if (img.complete) img.style.opacity = '';
      apply(false);
      counter.textContent = items.length > 1 ? `${idx + 1} / ${items.length}` : '';
      box.classList.toggle('single', items.length < 2);
      [idx + 1, idx - 1].forEach((j) => { if (items.length > 1) new Image().src = items[(j + items.length) % items.length].src; });
    };
    const close = () => {
      if (!box || box.hidden) return;
      box.hidden = true; document.documentElement.classList.remove('lb-open');
      const fig = $$('[data-gallery] figure')[idx];
      if (fig && isMobile()) fig.scrollIntoView({ inline: 'start', block: 'nearest' });
      opener?.focus?.({ preventScroll: true });
    };
    const build = () => {
      box = document.createElement('div'); box.className = 'lb'; box.hidden = true;
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Galería de imágenes');
      box.innerHTML = '<div class="lb-stage"><img class="lb-img" alt="" draggable="false"></div>' +
        '<button class="lb-btn lb-close" type="button" aria-label="Cerrar"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 3l12 12M15 3L3 15"/></svg></button>' +
        '<button class="lb-btn lb-prev" type="button" aria-label="Anterior"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M11 3L5 9l6 6"/></svg></button>' +
        '<button class="lb-btn lb-next" type="button" aria-label="Siguiente"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M7 3l6 6-6 6"/></svg></button>' +
        '<div class="lb-count" aria-live="polite"></div>' +
        '<div class="lb-zoom"><button class="lb-btn" type="button" data-z="-1" aria-label="Alejar">−</button><button class="lb-btn" type="button" data-z="1" aria-label="Acercar">+</button></div>';
      document.body.appendChild(box);
      stage = $('.lb-stage', box); img = $('.lb-img', box); counter = $('.lb-count', box);
      $('.lb-close', box).addEventListener('click', close);
      $('.lb-prev', box).addEventListener('click', () => show(idx - 1));
      $('.lb-next', box).addEventListener('click', () => show(idx + 1));
      $$('[data-z]', box).forEach((b) => b.addEventListener('click', () => {
        const r = stage.getBoundingClientRect(); zoomAt(s * (+b.dataset.z > 0 ? 1.6 : 1 / 1.6), r.left + r.width / 2, r.top + r.height / 2, true);
      }));
      stage.addEventListener('wheel', (e) => { e.preventDefault(); zoomAt(s * Math.exp(-e.deltaY * 0.0022), e.clientX, e.clientY, false); }, { passive: false });
      stage.addEventListener('dblclick', (e) => { e.preventDefault(); s > 1.01 ? zoomAt(1, e.clientX, e.clientY, true) : zoomAt(2.5, e.clientX, e.clientY, true); });
      stage.addEventListener('pointerdown', (e) => {
        stage.setPointerCapture(e.pointerId); ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        g0 = { x: e.clientX, y: e.clientY, tx, ty, s, t: Date.now(), moved: false };
        if (ptrs.size === 2) { const [a, b] = [...ptrs.values()]; g0.d = Math.hypot(a.x - b.x, a.y - b.y); g0.moved = true; }
      });
      stage.addEventListener('pointermove', (e) => {
        if (!ptrs.has(e.pointerId) || !g0) return;
        ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (ptrs.size === 2) {
          const [a, b] = [...ptrs.values()], d = Math.hypot(a.x - b.x, a.y - b.y);
          zoomAt(g0.s * d / (g0.d || d), (a.x + b.x) / 2, (a.y + b.y) / 2, false); return;
        }
        const dx = e.clientX - g0.x, dy = e.clientY - g0.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) g0.moved = true;
        if (s > 1.01) { tx = g0.tx + dx; ty = g0.ty + dy; clamp(); apply(false); }
        else { tx = dx; ty = Math.abs(dy) > Math.abs(dx) ? dy * 0.5 : 0; img.style.transition = 'none'; img.style.transform = `translate(${tx}px,${ty}px)`; }
      });
      const end = (e) => {
        if (!ptrs.has(e.pointerId)) return;
        ptrs.delete(e.pointerId);
        if (!g0) return;
        if (ptrs.size === 1) { const [p] = [...ptrs.values()]; g0 = { x: p.x, y: p.y, tx, ty, s, t: Date.now(), moved: true }; return; }
        if (ptrs.size > 0) return;
        const dx = e.clientX - g0.x, dy = e.clientY - g0.y, moved = g0.moved; g0 = null;
        if (s <= 1.01) {
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) && items.length > 1) { show(idx + (dx < 0 ? 1 : -1)); return; }
          if (dy > 110) { close(); return; }
          tx = 0; ty = 0; s = 1; apply(true);
        } else if (s < 1.05) { zoomAt(1, 0, 0, true); }
        if (!moved && e.pointerType === 'touch') {
          const now = Date.now();
          if (now - lastTap < 300) { s > 1.01 ? zoomAt(1, e.clientX, e.clientY, true) : zoomAt(2.5, e.clientX, e.clientY, true); lastTap = 0; } else lastTap = now;
        }
      };
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
      document.addEventListener('keydown', (e) => {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(idx + 1);
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === '+' || e.key === '=') { const r = stage.getBoundingClientRect(); zoomAt(s * 1.5, r.left + r.width / 2, r.top + r.height / 2, true); }
        else if (e.key === '-') { const r = stage.getBoundingClientRect(); zoomAt(s / 1.5, r.left + r.width / 2, r.top + r.height / 2, true); }
        else if (e.key === 'Tab') { e.preventDefault(); $('.lb-close', box).focus(); }
      });
      addEventListener('resize', () => { if (!box.hidden) { clamp(); apply(false); } });
    };
    const open = (fig) => {
      if (!box) build();
      const figs = $$('[data-gallery] figure');
      items = figs.map((f) => ({ src: f.dataset.full || f.querySelector('img')?.currentSrc || '', alt: f.querySelector('img')?.alt || '' })).filter((x) => x.src);
      opener = fig; box.hidden = false; document.documentElement.classList.add('lb-open');
      show(Math.max(0, figs.indexOf(fig)));
      $('.lb-close', box).focus({ preventScroll: true });
    };
    document.addEventListener('click', (e) => {
      const fig = e.target.closest?.('[data-gallery] figure'); if (fig) open(fig);
    });
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches?.('[data-gallery] figure')) { e.preventDefault(); open(e.target); }
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest?.('[data-rv-nav]'); if (!b) return;
    const l = b.closest('.rv-main')?.querySelector('.rv-list'); if (l) l.scrollBy({ left: +b.dataset.rvNav * l.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* tarjetas de producto: elegir color cambia la foto */
  (function () {
    const pick = (dot) => {
      const card = dot.closest('.card'); if (!card) return;
      $$('.sw-dot', card).forEach((d) => d.classList.toggle('on', d === dot));
      const base = card.getAttribute('href').split('?')[0];
      card.setAttribute('href', `${base}?variant=${dot.dataset.variant}`);
      const im = $('.ph img.a', card);
      if (im && dot.dataset.src) {
        im.removeAttribute('srcset'); im.src = dot.dataset.src;
        if (dot.dataset.srcset) im.setAttribute('srcset', dot.dataset.srcset);
        card.classList.add('sw-on');
      }
    };
    document.addEventListener('click', (e) => {
      const dot = e.target.closest?.('.card .sw-dot'); if (!dot) return;
      e.preventDefault(); e.stopPropagation(); pick(dot);
    }, true);
    document.addEventListener('pointerover', (e) => {
      const dot = e.target.closest?.('.card .sw-dot'); if (dot?.dataset.src && !dot._pre) { dot._pre = 1; new Image().src = dot.dataset.src; }
    });
  })();
  /* guardadas (marcador): se guardan en este dispositivo */
  const Saved = (() => {
    const KEY = 'elira_saved', cache = {};
    const read = () => { try { const a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } };
    const write = (a) => { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} };
    let style = document.createElement('style'); style.id = 'savedStyle'; document.head.appendChild(style);
    const esc2 = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const sync = () => {
      const list = read();
      style.textContent = list.map((h) => `.save-btn[data-save="${CSS.escape(h)}"]{color:var(--espresso)}.save-btn[data-save="${CSS.escape(h)}"] svg{fill:currentColor}`).join('');
      $$('.save-btn').forEach((b) => b.setAttribute('aria-pressed', list.includes(b.dataset.save) ? 'true' : 'false'));
      $$('[data-saved-count]').forEach((n) => (n.textContent = list.length ? String(list.length) : ''));
      $$('[data-saved-title-count]').forEach((n) => (n.textContent = list.length ? ` · ${list.length}` : ''));
    };
    const product = async (h) => {
      if (cache[h]) return cache[h];
      try { const r = await fetch(`${root}/products/${encodeURIComponent(h)}.js`); if (!r.ok) return null; return (cache[h] = await r.json()); } catch (e) { return null; }
    };
    const render = async () => {
      const list = read(), box = $('[data-saved-list]'), empty = $('[data-saved-empty]'); if (!box) return;
      empty.hidden = list.length > 0;
      const items = (await Promise.all(list.map(product)));
      box.innerHTML = items.map((p, i) => {
        if (!p) return '';
        const parts = p.title.split(' - '), sub = parts[1] ? parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase() : '';
        const img = p.featured_image ? `<img src="${esc2(p.featured_image)}${p.featured_image.includes('?') ? '&' : '?'}width=360" alt="" loading="lazy">` : '';
        const cmp = p.compare_at_price > p.price ? `<s>${money(p.compare_at_price)}</s>` : '';
        const first = p.variants.find((v) => v.available) || p.variants[0];
        const selects = (p.options || []).map((o, k) => {
          const vals = o.values || [];
          if (!vals.length || (vals.length === 1 && p.options.length > 1)) return '';
          if (vals.length === 1) return '';
          return `<select class="sv-sel" data-opt="${k}" aria-label="${esc2(o.name)}">${vals.map((val) => `<option value="${esc2(val)}"${first && first.options[k] === val ? ' selected' : ''}>${esc2(val)}</option>`).join('')}</select>`;
        }).join('');
        const dis = p.available ? '' : ' disabled';
        return `<div class="sv-item" data-handle="${esc2(list[i])}"><div class="sv-media"><a href="${esc2(p.url)}">${img}</a><button type="button" class="sv-move" data-save-move="${esc2(list[i])}"${dis}>${p.available ? 'Mover al carrito' : 'Agotado'}</button></div><div class="sv-info"><a href="${esc2(p.url)}"><span class="n">${esc2(parts[0])}</span>${sub ? `<span class="v">${esc2(sub)}</span>` : ''}</a><span class="p">${money(p.price)}${cmp}</span>${selects ? `<div class="sv-sels">${selects}</div>` : ''}</div><button type="button" class="rm" data-save-remove="${esc2(list[i])}">Quitar</button></div>`;
      }).join('');
    };
    const move = async (btn) => {
      const h = btn.dataset.saveMove, p = await product(h), row = btn.closest('.sv-item'); if (!p || !row) return;
      const chosen = (p.options || []).map((o, k) => { const sel = $(`select[data-opt="${k}"]`, row); return sel ? sel.value : (o.values || [])[0]; });
      const v = p.variants.find((x) => chosen.every((c, k) => x.options[k] === c));
      if (!v || !v.available) { toast('Esa combinación no está disponible'); return; }
      btn.disabled = true;
      try {
        const r = await fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-drawer', sections_url: location.pathname }) });
        const j = await r.json();
        if (!r.ok) { toast(j.description || S.error); btn.disabled = false; return; }
        toggle(h, false);
        if (j.sections && j.sections['cart-drawer']) swapDrawer(j.sections['cart-drawer']); else await refreshCart();
        toast(S.added); openDrawer('cart');
      } catch (err) { toast(S.error); btn.disabled = false; }
    };
    const toggle = (h, force) => {
      const list = read(), has = list.includes(h), on = force == null ? !has : force;
      if (on && !has) list.push(h); else if (!on && has) list.splice(list.indexOf(h), 1); else return;
      write(list); sync();
      if ($('#saved')?.classList.contains('on')) render();
      return on;
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest?.('[data-save]');
      if (b) { e.preventDefault(); e.stopPropagation(); const on = toggle(b.dataset.save); if (on != null) toast(on ? 'Añadido a destacadas' : 'Quitado de destacadas'); return; }
      const mv = e.target.closest?.('[data-save-move]');
      if (mv) { e.preventDefault(); e.stopPropagation(); move(mv); return; }
      const rm = e.target.closest?.('[data-save-remove]');
      if (rm) { e.preventDefault(); toggle(rm.dataset.saveRemove, false); return; }
      const o = e.target.closest?.('[data-open="saved"]'); if (o) render();
    }, true);
    addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
    addEventListener('pageshow', sync);
    sync();
    return { sync, render };
  })();
  /* nota y total de reseñas de toda la tienda (se calcula con las valoraciones de cada producto) */
  (function () {
    const KEY = 'elira_store_rating', TTL = 6 * 3600 * 1000;
    const read = () => { try { const o = JSON.parse(localStorage.getItem(KEY) || 'null'); return o && Date.now() - o.t < TTL ? o : null; } catch (e) { return null; } };
    const fill = (o) => {
      $$('[data-store-rating]').forEach((a) => {
        const st = $('.stars-r', a); if (st) { st.style.setProperty('--pct', `${Math.max(0, Math.min(100, o.avg * 20))}%`); st.setAttribute('aria-label', `${o.avg.toFixed(1).replace('.', ',')} de 5 estrellas`); }
        $('[data-sr-avg]', a).textContent = o.avg.toFixed(1).replace('.', ',');
        $('[data-sr-count]', a).textContent = o.count.toLocaleString('es-ES');
        a.hidden = false;
      });
    };
    const load = async () => {
      let o = read();
      if (!o) {
        try {
          let page = 1, pages = 1, count = 0, sum = 0;
          do {
            const r = await fetch(`${root}/collections/all?view=ratings&page=${page}`); if (!r.ok) throw 0;
            const j = JSON.parse((await r.text()).trim());
            pages = j.pages || 1;
            j.items.forEach(([c, a]) => { c = +c || 0; a = +a || 0; if (c > 0 && a > 0) { count += c; sum += c * a; } });
            page++;
          } while (page <= pages && page <= 10);
          if (count > 0) { o = { t: Date.now(), count, avg: sum / count }; try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
        } catch (e) {}
      }
      if (o) fill(o);
    };
    const go = () => { if ($('[data-store-rating]')) load(); };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
    document.addEventListener('shopify:section:load', go);
  })();
  function initMobile() {
    const setFooter = () => $$('.fcol').forEach((d) => { if (!isMobile()) d.open = true; });
    if (isMobile()) $$('.fcol').forEach((d) => (d.open = false));
    setFooter();
    $$('.fcol summary').forEach((s) => s.addEventListener('click', (e) => { if (!isMobile()) e.preventDefault(); }));
    mq.addEventListener?.('change', () => { setFooter(); measure(); tick(); });
    $$('.hscroll').forEach((hs) => { const w = $('.rail-wrap', hs); if (w) { w.classList.add('scroller'); railProgress(w, hs); } });
    $$('[data-gallery]').forEach(initGallery);
    initLightbox();
    const tb = $('.tabbar');
    if (tb) {
      let last = scrollY;
      addEventListener('scroll', () => { const y = scrollY; if (y > 400 && y > last + 6) tb.style.transform = 'translateY(110%)'; else if (y < last - 6 || y < 400) tb.style.transform = ''; last = y; }, { passive: true });
    }
  }

  function stars(r) { return `<span class="stars-r" style="--pct:${Math.max(0, Math.min(100, r * 20))}%;font-size:.85rem" role="img" aria-label="${r} / 5"><span aria-hidden="true">★★★★★</span></span>`; }
  function reviewCard(r) {
    const pics = (r.pictures_urls || []).slice(0, 4).map((p) => { const src = (p && (p.compact || p.small || p.original)) || p; const big = (p && p.original) || src; return `<a href="${esc(big)}" target="_blank" rel="noopener"><img src="${esc(src)}" alt="" loading="lazy" width="96" height="96"></a>`; }).join('');
    const initial = (r.reviewer_initial || r.reviewer_name || '?').charAt(0);
    return `<li class="rv-card" data-rating="${r.rating}" data-photos="${(r.pictures_urls || []).length}">
      <div class="rv-top">${stars(r.rating)}</div>
      ${r.title ? `<h3 class="rv-title">${esc(r.title)}</h3>` : ''}
      <div class="rv-body">${esc(r.body || '').replace(/\n/g, '<br>')}</div>
      ${pics ? `<div class="rv-pics">${pics}</div>` : ''}
      <div class="rv-who"><span class="rv-avatar" aria-hidden="true">${esc(initial)}</span><span><b>${esc(r.reviewer_name || '')}</b>${r.location ? ' · ' + esc(r.location) : ''}</span>${r.verified_buyer ? `<span class="rv-verified">✓ Compra verificada</span>` : ''}${r.product_variant_title ? `<span class="small">Compró: ${esc(r.product_variant_title)}</span>` : ''}</div>
      ${r.reply_content ? `<div class="rv-reply">${esc(String(r.reply_content).replace(/<[^>]+>/g, ''))}</div>` : ''}
    </li>`;
  }
  function clampBodies(scope) {
    $$('.rv-body:not([data-clamped])', scope).forEach((b) => {
      b.dataset.clamped = '1';
      b.classList.add('clamp');
      if (b.scrollHeight <= b.clientHeight + 2) { b.classList.remove('clamp'); return; }
      const more = document.createElement('button');
      more.type = 'button'; more.className = 'rv-readmore'; more.textContent = 'Leer más';
      more.addEventListener('click', () => { const open = b.classList.toggle('clamp'); more.textContent = open ? 'Leer más' : 'Leer menos'; });
      b.after(more);
    });
  }
  function initReviews(sec) {
    const list = $('[data-list]', sec), moreBtn = $('[data-more]', sec), empty = $('.rv-filter-empty', sec);
    const pages = +sec.dataset.pages || 1;
    let page = 1, filter = 'all', loading = false;
    if (list) clampBodies(list);
    async function loadPage() {
      if (loading || page >= pages) return;
      loading = true;
      if (moreBtn) { moreBtn.disabled = true; moreBtn.dataset.label = moreBtn.dataset.label || moreBtn.textContent; moreBtn.textContent = 'Cargando…'; }
      try {
        const url = `https://judge.me/reviews/reviews_for_widget?url=${encodeURIComponent(sec.dataset.shop)}&shop_domain=${encodeURIComponent(sec.dataset.shop)}&platform=shopify&page=${page + 1}&per_page=5&product_id=${sec.dataset.productId}`;
        const r = await fetch(url);
        const j = await r.json();
        page++;
        list.insertAdjacentHTML('beforeend', (j.reviews || []).map(reviewCard).join(''));
        clampBodies(list);
      } catch (e) { toast(S.error); }
      loading = false;
      if (moreBtn) { moreBtn.disabled = false; moreBtn.textContent = moreBtn.dataset.label; moreBtn.hidden = page >= pages; }
      apply();
    }
    async function loadAll() { while (page < pages) { const before = page; await loadPage(); if (page === before) break; } }
    function apply() {
      let shown = 0;
      $$('.rv-card', list).forEach((c) => {
        const ok = filter === 'all' || (filter === 'photos' ? +c.dataset.photos > 0 : c.dataset.rating === filter);
        c.hidden = !ok; if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      $$('[data-filter]', sec).forEach((b) => b.classList.toggle('on', b.dataset.filter === filter));
    }
    sec.addEventListener('click', async (e) => {
      const f = e.target.closest('[data-filter]');
      if (f && !f.disabled) {
        filter = f.dataset.filter === filter && f.classList.contains('rv-bar') ? 'all' : f.dataset.filter;
        if (filter !== 'all') await loadAll();
        apply();
        if (f.classList.contains('rv-bar') && isMobile()) $('.rv-main', sec)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (e.target.closest('[data-more]')) { loadPage(); return; }
      if (e.target.closest('[data-write-review]')) {
        const box = $('[data-write-box]', sec);
        const find = () => box.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link, [class*="write-review"] button');
        const go = (b) => { if (b) b.click(); else toast('El formulario de reseñas se está cargando, inténtalo en unos segundos.'); };
        const b = find();
        if (b) go(b);
        else { let tries = 0; const t = setInterval(() => { const x = find(); if (x || ++tries > 16) { clearInterval(t); go(x); } }, 250); }
      }
    });
  }
  function initSizeGuide(scope = document) {
    const dlg = $('[data-size-dialog]', scope);
    if (!dlg) return;
    scope.addEventListener('click', (e) => {
      if (e.target.closest('[data-size-guide]')) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); }
      if (e.target.closest('[data-size-close]') || e.target === dlg) dlg.close ? dlg.close() : dlg.removeAttribute('open');
    });
  }

  function initLook(dlg) {
    if (!dlg || dlg.dataset.ready) return;
    dlg.dataset.ready = '1';
    const items = $$('[data-look-item]', dlg).map((el) => {
      const data = JSON.parse($('[data-look-json]', el).textContent);
      const first = data.variants.find((v) => v.available) || data.variants[0];
      return { el, data, sel: [...first.options], on: true };
    });
    const find = (st) => st.data.variants.find((v) => v.options.every((o, i) => o === st.sel[i]));
    const avail = (st, i, val) => st.data.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || o === st.sel[j]));
    const draw = () => {
      let total = 0, count = 0;
      items.forEach((st) => {
        const v = find(st);
        const ok = !!(v && v.available);
        const only = st.data.options.length === 1 && /title|t[ií]tulo/i.test(st.data.options[0]);
        $('[data-look-opts]', st.el).innerHTML = only ? '' : st.data.options.map((name, i) => {
          const vals = [...new Set(st.data.variants.map((x) => x.options[i]))];
          return `<div class="opt"><div class="lab"><span class="lab-n">${esc(name)}: <span style="text-transform:none;letter-spacing:0">${esc(st.sel[i])}</span></span></div><div class="vals">${vals.map((val) => `<button type="button" class="val${val === st.sel[i] ? ' on' : ''}${avail(st, i, val) ? '' : ' na'}" data-i="${i}" data-v="${esc(val)}">${esc(val)}</button>`).join('')}</div></div>`;
        }).join('');
        const pv = v || st.data.variants[0];
        $('[data-look-price]', st.el).innerHTML = !ok ? `<span class="small">${esc(dlg.dataset.labelSold)}</span>` : pv.compare > pv.price ? `<span style="color:var(--sale)">${money(pv.price)}</span> <s class="small">${money(pv.compare)}</s>` : money(pv.price);
        const img = $('.look-thumb', st.el); if (v && v.image && img.getAttribute('src') !== v.image) img.src = v.image;
        const chk = $('[data-look-check]', st.el); chk.checked = st.on && ok; chk.disabled = !ok;
        st.el.classList.toggle('off', !(st.on && ok));
        if (st.on && ok) { total += v.price; count++; }
      });
      const pct = +dlg.dataset.discount || 0;
      const full = count === items.length && count > 1;
      let final = total, saved = 0;
      if (pct && full) { saved = items.reduce((a, st) => { const v = find(st); return st.on && v && v.available ? a + Math.round(v.price * pct / 100) : a; }, 0); final = total - saved; }
      $('[data-look-total]', dlg).innerHTML = saved ? `<s class="small" style="margin-right:.5rem;color:var(--muted)">${money(total)}</s><span style="color:var(--sale)">${money(final)}</span>` : money(total);
      const hint = $('[data-look-hint]', dlg);
      if (hint) { hint.hidden = !pct || count === 0; hint.className = 'look-hint small' + (saved ? ' ok' : ''); hint.textContent = saved ? `${dlg.dataset.labelSave} ${money(saved)} (-${pct} %)` : dlg.dataset.labelHint; }
      const b = $('[data-look-add]', dlg);
      b.disabled = count === 0;
      b.textContent = count === 0 ? dlg.dataset.labelNone : `${dlg.dataset.labelAdd} · ${money(final)}`;
    };
    dlg.addEventListener('click', async (e) => {
      if (e.target === dlg || e.target.closest('[data-look-close]')) { dlg.close ? dlg.close() : dlg.removeAttribute('open'); return; }
      const val = e.target.closest('.val');
      if (val) { const st = items.find((x) => x.el.contains(val)); st.sel[+val.dataset.i] = val.dataset.v; draw(); return; }
      if (e.target.closest('[data-look-add]')) {
        const lines = items.map((st) => ({ st, v: find(st) })).filter((x) => x.st.on && x.v && x.v.available).map((x) => ({ id: x.v.id, quantity: 1 }));
        if (!lines.length) return;
        const b = e.target.closest('[data-look-add]'); b.disabled = true;
        try {
          const r = await fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines, sections: 'cart-drawer', sections_url: location.pathname }) });
          const j = await r.json();
          if (!r.ok) { toast(j.description || S.error); b.disabled = false; return; }
          if (j.sections && j.sections['cart-drawer']) swapDrawer(j.sections['cart-drawer']); else await refreshCart();
          dlg.close ? dlg.close() : dlg.removeAttribute('open');
          toast(S.added);
          openDrawer('cart');
        } catch (err) { toast(S.error); }
        draw();
      }
    });
    dlg.addEventListener('change', (e) => { const c = e.target.closest('[data-look-check]'); if (!c) return; const st = items.find((x) => x.el.contains(c)); st.on = c.checked; draw(); });
    draw();
  }

  function initCountdown(sec) {
    if (!sec || sec.dataset.cdReady) return;
    sec.dataset.cdReady = '1';
    const target = Date.parse(sec.dataset.start);
    if (isNaN(target)) return;
    const set = (k, v) => { const el = $(`[data-cd="${k}"]`, sec); if (el) el.textContent = String(v).padStart(2, '0'); };
    const tick2 = () => {
      let diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60);
      set('d', d); set('h', h); set('m', m); set('s', diff - m * 60);
      return target > Date.now();
    };
    if (!tick2()) return;
    const iv = setInterval(() => { if (!document.body.contains(sec) || !tick2()) clearInterval(iv); }, 1000);
  }

  function init() {
    $$('.announce .track').forEach((el) => marquees.push({ el, x: 0, speed: 0.45, scroll: false }));
    $$('.words .row').forEach((el) => marquees.push({ el, x: 0, speed: 0.6, scroll: true }));
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));
    initSearch();
    initContact();
    initMobile();
    $$('[data-reviews]').forEach(initReviews);
    initSizeGuide();
    $$('[data-countdown]').forEach(initCountdown);
    $$('[data-look-dialog]').forEach(initLook);
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-look-open]')) return; const d = $('[data-look-dialog]'); if (d) d.showModal ? d.showModal() : d.setAttribute('open', ''); });
    armReveals();
    measure();
    tick();
    requestAnimationFrame(loop);
    addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', (e) => { $$('[data-countdown]', e.target).forEach(initCountdown); $$('[data-look-dialog]', e.target).forEach(initLook); $$('[data-product-section]', e.target).forEach(initProduct); armReveals(e.target); measure(); tick(); });
})();
